import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { filterNonNoOpCBEs } from "../../../../helpers/cbeUtils";
import useFetchCrossStageDetails from "../../../../hooks/useFetchCrossStageDetails";

export const useCrossStageData = (
  crossStageEnabled: boolean,
  compareStage: string,
  currentStage: string,
  overrideId: string,
  identifier: string,
  flowType: string
) => {
  const fetchCrossStageDetails = useFetchCrossStageDetails();
  const idToUse = overrideId || identifier;
  const queryKey = ["crossStageData", compareStage, idToUse, flowType];

  const isQueryEnabled = Boolean(
    crossStageEnabled && compareStage !== currentStage && compareStage
  );

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: () => fetchCrossStageDetails(compareStage, idToUse, flowType),
    enabled: isQueryEnabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: false,
  });

  const crossStageData = useMemo(() => {
    if (!data) return { events: [], cbes: [] };

    const filteredCbes = filterNonNoOpCBEs(data.cbes);
    const filteredRawCbes = filterNonNoOpCBEs(data.rawCbes);

    return {
      events: data.events,
      cbes: filteredCbes,
      rawCbes: filteredRawCbes,
    };
  }, [data]);

  const crossStageRawData = useMemo(() => {
    return data?.rawTotals || { totalEvents: 0, totalCbes: 0 };
  }, [data?.rawTotals]);

  return {
    crossStageData,
    crossStageRawData,
    crossStageLoading: isQueryEnabled && isLoading,
    error,
  };
};
